module.exports = __webpack_public_path__ + "static/media/WEB17.7dd7ff79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB17.jpg
// module id = 86
// module chunks = 0